import { Stack, InputLabel } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { DatePickerElement, DatePickerElementProps } from "react-hook-form-mui";
import { useTranslations } from "next-intl";

export const FormDatePicker = ({
  disabled,
  label,

  ...props
}: DatePickerElementProps<any, any>) => {
  const t = useTranslations();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={1} sx={{ opacity: disabled ? 0.7 : 1 }}>
        <InputLabel
          sx={{ fontWeight: 500, lineHeight: 1, textTransform: "capitalize" }}
        >
          {typeof label === "string" ? t(label) : label}
        </InputLabel>
        <DatePickerElement
          disabled={disabled}
          {...props}
          inputProps={{
            sx: {
              borderRadius: "0.5rem",
              input: {
                padding: 1.6,
              },
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};
